// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfQuarter as fn } from "../lastDayOfQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfQuarter = convertToFP(fn, 1);

// Fallback for modularized imports:
export default lastDayOfQuarter;
